
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.333 6.667C4.603 6.667 4 7.27 4 8v16c0 .73.603 1.333 1.333 1.333h21.334c.73 0 1.333-.603 1.333-1.333V8c0-.73-.603-1.333-1.333-1.333H5.333zM1.333 8c0-2.203 1.797-4 4-4h21.334c2.203 0 4 1.797 4 4v16c0 2.203-1.797 4-4 4H5.333c-2.203 0-4-1.797-4-4V8z","fill":"#BD2C43"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.574 7.235a1.333 1.333 0 011.857-.327L16 15.706l12.569-8.798a1.333 1.333 0 011.529 2.184l-13.333 9.334c-.46.321-1.07.321-1.53 0L1.902 9.092a1.333 1.333 0 01-.328-1.857z","fill":"#BD2C43"}})])
          )
        }
      }
    